import { Component, Input } from '@angular/core';
import { UserGroup } from "../../../app/app.interfaces";

@Component({
  selector: 'user-group-tag',
  templateUrl: 'user-group-tag.html'
})
export class UserGroupTag {
  @Input() userGroup: UserGroup;
  @Input() fullName: boolean = false;

  @Input() iconOnly: boolean;
  
}


// WEBPACK FOOTER //
// ./src/partials/user-group/user-group-tag/user-group-tag.ts